module.exports = __webpack_public_path__ + "static/img/szrl41.387a2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szrl41.png
// module id = W/Rz
// module chunks = 73